import { createContext } from 'react';

const CateringSearchContext = createContext();
CateringSearchContext.displayName = 'CateringSearchContext';

export default CateringSearchContext;
